import React from 'react';
import styles from './SignatureType.module.sass';

import ChooseItem from "../../components/ChooseItem/ChooseItem";
import Button from "../../components/ui/Button/Button";

const SignatureType = (props) => {
  return (
    <ChooseItem
      className={styles.chooseContent}>
      <Button
          onClick={() => props.signatureChosen("EMAIL")}>
          E-mail
      </Button>
      <Button
        onClick={() => props.signatureChosen("SMS")}>
        SMS
      </Button>
  </ChooseItem>
  )
};

export default SignatureType
